import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-y-4" }


import { AccessorySearchResult } from '../../types';
import transformYear from '../../utils/transformYear';


export default /*#__PURE__*/_defineComponent({
  props: {
    accessory: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.accessory.properties.name) + " - " + _toDisplayString(__props.accessory.articleIdCustomer) + " - " + _toDisplayString(_unref(transformYear)(__props.accessory.year)), 1),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, _toDisplayString(__props.accessory.properties.text), 1)
    ])
  ], 64))
}
}

})